import { render } from "./PropertyGallery.vue?vue&type=template&id=261f39d8"
import script from "./PropertyGallery.vue?vue&type=script&lang=js"
export * from "./PropertyGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__